import React, {useContext, useEffect, useState} from 'react';
import { MobileMenuContext } from '../../../common/context/mobile-menu-context';
import styles from './NavBar.module.css';
import RightNav from "../../../common/navigation/right/right-nav";

const NavBar = () => {
    const {isMobileMenuOpen, setIsMobileMenuOpen} = useContext(MobileMenuContext);
    const[isMobileView, setIsMobileView] = useState<boolean>(false);

    const closeMobileMenu = () => {
        setIsMobileMenuOpen(!isMobileMenuOpen);
    };

    useEffect(() => {
        const handleResize = () => {
            setIsMobileView(window.innerWidth <= 768);
        };

        handleResize();
        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <nav className="navbar navbar-expand-lg fixed-top py-3" style={{backgroundColor:'white'}}>

            <div className={`container-fluid px-3 px-lg-5 ${styles.nav_sub_div}`}>
                <a className="nav-link navbar-brand d-flex align-items-center " href="/">
                    <img
                        src="/images/logo/logo resize.png"
                        alt="Logo placeholder"
                        className={styles.logo}
                    />
                    <div className={styles.business_name_container}
                         style={{
                             display: 'flex',
                             flexDirection: 'column',
                             lineHeight: '1',
                             color: "#113265",
                             marginLeft: "10px"
                         }}
                    >
                        <span style={{fontFamily: "K2D"}}>Garderie</span>
                        <span style={{fontFamily: "'Cookie', cursive", fontSize: "34px"}}>La Belle Étoile</span>
                    </div>
                </a>
                {/*<div className={styles.business_name_container}*/}
                {/*     style={{display: 'flex', flexDirection: 'column', lineHeight: '1', color: "#113265",marginLeft:"10px"}}*/}
                {/*>*/}
                {/*    <span style={{fontFamily: "K2D"}}>Garderie</span>*/}
                {/*    <span style={{fontFamily: "'Cookie', cursive", fontSize: "34px"}}>La Belle Étoile</span>*/}
                {/*</div>*/}
                <button
                    className="navbar-toggler"
                    type="button"
                    onClick={closeMobileMenu}
                    aria-controls="navbarSupportedContent"
                    aria-expanded={!isMobileMenuOpen}
                    aria-label="Toggle navigation"
                >
                    <span className="navbar-toggler-icon"></span>
                </button>

                <div
                    className={`collapse navbar-collapse ${
                        !isMobileMenuOpen ? '' : 'show'
                    }`}
                    id="navbarSupportedContent"
                >
                    <RightNav/>
                </div>

            </div>
        </nav>
    );
};

export default NavBar;